import {api} from "../../../common/config";
import {StorageUtil} from '../../../common/Auth.js';
import {store} from "../../../store/store";
import {ajaxUtil} from "../../../common/AjaxUtil";

export default {
    name: 'notecontent',
    data() {
        return {
            noteList: [],
            bookId: 0,
            readerId: '',
            bookName: '',
            typeId: 1   //1新增   2修改
        }
    },
    mounted() {
        store.personal._this.activeNav = "读书笔记";
        this.bookId = this.$route.query.bookId;
        this.readerId = this.$route.query.readerId;
        this.bookName = this.$route.query.bookName;
        this.getList();
    },
    methods: {
      getList() {
        this.pageNo = this.$route.query.page || 1;
        var url = api.note.noteDetail.replace('{readerId}', this.readerId).replace('{bookId}', this.bookId);
        ajaxUtil.ajaxJson(url, null, "GET", (data) => {
          if(data != null){
              this.noteList = data.resultList
          }else{
              this.$router.push({path: '/notelist'})
          }
        }, null, this);
      },
      /*跳转到新增笔记页面
       @param bookId
     * */
      editNote() {
        this.typeId = 1;
        this.$router.push({path: '/editnote', query: { 'bookName': this.bookName, 'bookId': this.bookId, 'typeId': this.typeId }})
      },
      /*跳转到编辑页面
        @param 笔记的id号
      * */
      onSkip(item) {
        this.typeId = 2;
        StorageUtil.storeObject("noteContentEdit", item);
        this.$router.push({path: '/editnote', query: { 'bookName': this.bookName, 'bookId': item.bookId, 'typeId': this.typeId, 'noteId': item.id}})
      },

        /*删除笔记
        @param 笔记的id号
      * */
        deleteNote(item) {
            var url = api.note.delNote;
            var setData={
                id: item.id
            }
            ajaxUtil.ajaxJson(url, setData, "delete", (data) => {
                this.getList();
            }, null, this);
        },
    }
}
